import type {
  AnchorSectionsStoryblok,
  BigCampaignBlockItemStoryblok,
  FareStoryblok,
  FareTypesStoryblok,
  SmallCampaignBlockItemStoryblok,
  SmallCampaignBlockItemWithImageOnTopStoryblok
} from '@/storyblok/component-types-sb'
import { fakeISbStoryData } from '@/utils/tests/fakeISbStoryData'

export const clpData = {
  _uid: '915f1ba3-8761-46bb-9e73-9c336991c103',
  bgImage: {
    id: 17927344,
    alt: 'test',
    name: '',
    focus: '',
    title: 'test',
    source: '',
    filename: 'https://a.storyblok.com/f/260755/1920x2689/f4e2f2af5e/overlay2.png',
    copyright: '',
    fieldtype: 'asset',
    meta_data: { alt: 'test', title: 'test', source: '', copyright: '' },
    is_external_url: false
  },
  component: 'clp',
  endedBody: [
    {
      _uid: '2bc0186e-1901-4bd4-ad28-d86712c4273c',
      title: 'Cherry Deals Campaign ended',
      component: 'clp-ended-banner',
      description:
        'Hot Cherry Deals campaign is over. Feel free to explore our other destinations offers and other campaigns below on this page',
      _editable:
        '<!--#storyblok#{"name": "clp-ended-banner", "space": "260755", "uid": "2bc0186e-1901-4bd4-ad28-d86712c4273c", "id": "568258268"}-->'
    },
    {
      _uid: '6ade1561-3cf8-45bd-b80b-84dcf3a051c4',
      body: [
        {
          _uid: '3ed5312a-6da6-4f83-bf41-1065aa4dd0fa',
          title: 'Explore this summer top destinations',
          component: 'best-buy-banner',
          _editable:
            '<!--#storyblok#{"name": "best-buy-banner", "space": "260755", "uid": "3ed5312a-6da6-4f83-bf41-1065aa4dd0fa", "id": "568258268"}-->'
        },
        {
          _uid: '3ba58b49-7d0c-42f3-bcd7-e54557700f16',
          title: 'Explore actual promotions',
          offers: [
            {
              name: 'Become a corporate client',
              created_at: '2024-03-13T07:45:51.104Z',
              published_at: '2024-11-11T11:05:28.397Z',
              id: 460825081,
              uuid: 'ad9610ed-ad25-46a6-92ce-15164fe16690',
              content: {
                _uid: '43fc482d-c397-46bb-8275-f64489fcb627',
                link: {
                  name: 'Become a corporate client',
                  created_at: '2024-05-15T12:46:56.271Z',
                  published_at: '2024-05-15T13:09:15.094Z',
                  id: 496079155,
                  uuid: '2229fb55-bfd9-489e-a167-33ea02758e14',
                  content: {
                    _uid: 'a5ff9799-6d7e-435f-8a5a-7ae55cf392ac',
                    href: {
                      id: '',
                      url: '/en/corporate-register',
                      linktype: 'url',
                      fieldtype: 'multilink',
                      cached_url: '/en/corporate-register'
                    },
                    icon: '',
                    text: 'Read more',
                    image: {
                      id: null,
                      alt: null,
                      name: '',
                      focus: null,
                      title: null,
                      source: null,
                      filename: '',
                      copyright: null,
                      fieldtype: 'asset',
                      meta_data: {}
                    },
                    isCard: false,
                    component: 'link',
                    description: '',
                    whitelistCountries: [],
                    _editable:
                      '<!--#storyblok#{"name": "link", "space": "260755", "uid": "a5ff9799-6d7e-435f-8a5a-7ae55cf392ac", "id": "496079155"}-->'
                  },
                  slug: 'become-a-corporate-client',
                  full_slug: 'data/links/become-a-corporate-client',
                  sort_by_date: null,
                  position: -1310,
                  tag_list: [],
                  is_startpage: false,
                  parent_id: 419529671,
                  meta_data: null,
                  group_id: '2f561f08-bb0f-4ed3-bc87-d2ab34de8c4a',
                  first_published_at: '2024-05-15T12:47:14.554Z',
                  release_id: null,
                  lang: 'default',
                  path: null,
                  alternates: [],
                  default_full_slug: 'data/links/become-a-corporate-client',
                  translated_slugs: [
                    { path: 'data/links/become-a-corporate-client', name: null, lang: 'lv', published: null },
                    { path: 'data/links/become-a-corporate-client', name: null, lang: 'lt', published: null },
                    { path: 'data/links/become-a-corporate-client', name: null, lang: 'de', published: null },
                    { path: 'data/links/become-a-corporate-client', name: null, lang: 'et', published: null },
                    { path: 'data/links/become-a-corporate-client', name: null, lang: 'fi', published: null },
                    { path: 'data/links/become-a-corporate-client', name: null, lang: 'ru', published: null },
                    { path: 'data/links/become-a-corporate-client', name: null, lang: 'no', published: null },
                    { path: 'data/links/become-a-corporate-client', name: null, lang: 'fr', published: null },
                    { path: 'data/links/become-a-corporate-client', name: null, lang: 'uk', published: null }
                  ],
                  _stopResolving: true
                },
                title: 'Become a corporate client',
                blackList: ['lv'],
                component: 'offers',
                description: '',
                backgroundColor: '',
                backgroundImage: {
                  id: null,
                  alt: null,
                  name: '',
                  focus: null,
                  title: null,
                  source: null,
                  filename: '',
                  copyright: null,
                  fieldtype: 'asset',
                  meta_data: {}
                },
                _editable:
                  '<!--#storyblok#{"name": "offers", "space": "260755", "uid": "43fc482d-c397-46bb-8275-f64489fcb627", "id": "460825081"}-->'
              },
              slug: 'become-a-corporate-client',
              full_slug: 'data/offers/become-a-corporate-client',
              sort_by_date: null,
              position: -30,
              tag_list: [],
              is_startpage: false,
              parent_id: 442072860,
              meta_data: null,
              group_id: '5c974d1c-3eac-40a8-b88f-682652e81d66',
              first_published_at: '2024-05-15T12:51:53.168Z',
              release_id: null,
              lang: 'default',
              path: null,
              alternates: [],
              default_full_slug: 'data/offers/become-a-corporate-client',
              translated_slugs: [
                { path: 'data/offers/become-a-corporate-client', name: null, lang: 'lv', published: null },
                { path: 'data/offers/become-a-corporate-client', name: null, lang: 'lt', published: null },
                { path: 'data/offers/become-a-corporate-client', name: null, lang: 'de', published: null },
                { path: 'data/offers/become-a-corporate-client', name: null, lang: 'et', published: null },
                { path: 'data/offers/become-a-corporate-client', name: null, lang: 'fi', published: null },
                { path: 'data/offers/become-a-corporate-client', name: null, lang: 'ru', published: null },
                { path: 'data/offers/become-a-corporate-client', name: null, lang: 'no', published: null },
                { path: 'data/offers/become-a-corporate-client', name: null, lang: 'fr', published: null },
                { path: 'data/offers/become-a-corporate-client', name: null, lang: 'uk', published: null }
              ],
              _stopResolving: true
            },
            {
              name: 'Discover our NEW ticket types!',
              created_at: '2024-09-25T05:26:55.236Z',
              published_at: '2024-11-11T10:42:06.437Z',
              id: 553512371,
              uuid: 'a844ca39-1b23-40cb-81b0-12eae244ca8f',
              content: {
                _uid: '52d53d0e-24a6-40a7-9d41-70486571371c',
                link: {
                  name: 'Discover our NEW ticket types!',
                  created_at: '2024-09-25T05:22:00.139Z',
                  published_at: '2024-09-25T05:22:19.890Z',
                  id: 553512362,
                  uuid: 'ecdcdf6a-7573-441c-980a-bbe218b89eaf',
                  content: {
                    _uid: 'beddd99a-4d81-4b62-a2d8-044b1d841dfd',
                    href: {
                      id: '',
                      url: 'https://www.airbaltic.com/en/airbaltic-ticket-types ',
                      linktype: 'url',
                      fieldtype: 'multilink',
                      cached_url: 'https://www.airbaltic.com/en/airbaltic-ticket-types '
                    },
                    icon: '',
                    text: 'Discover our NEW ticket types!',
                    image: {
                      id: null,
                      alt: null,
                      name: '',
                      focus: null,
                      title: null,
                      source: null,
                      filename: '',
                      copyright: null,
                      fieldtype: 'asset',
                      meta_data: {}
                    },
                    isCard: false,
                    component: 'link',
                    description: '',
                    whitelistCountries: [],
                    _editable:
                      '<!--#storyblok#{"name": "link", "space": "260755", "uid": "beddd99a-4d81-4b62-a2d8-044b1d841dfd", "id": "553512362"}-->'
                  },
                  slug: 'discover-our-new-ticket-types',
                  full_slug: 'data/links/discover-our-new-ticket-types',
                  sort_by_date: null,
                  position: -1760,
                  tag_list: [],
                  is_startpage: false,
                  parent_id: 419529671,
                  meta_data: null,
                  group_id: '641043fe-7806-486f-9b2b-f807b921b40f',
                  first_published_at: '2024-09-25T05:22:19.890Z',
                  release_id: null,
                  lang: 'default',
                  path: null,
                  alternates: [],
                  default_full_slug: 'data/links/discover-our-new-ticket-types',
                  translated_slugs: [
                    { path: 'data/links/discover-our-new-ticket-types', name: null, lang: 'lv', published: null },
                    { path: 'data/links/discover-our-new-ticket-types', name: null, lang: 'lt', published: null },
                    { path: 'data/links/discover-our-new-ticket-types', name: null, lang: 'de', published: null },
                    { path: 'data/links/discover-our-new-ticket-types', name: null, lang: 'et', published: null },
                    { path: 'data/links/discover-our-new-ticket-types', name: null, lang: 'fi', published: null },
                    { path: 'data/links/discover-our-new-ticket-types', name: null, lang: 'ru', published: null },
                    { path: 'data/links/discover-our-new-ticket-types', name: null, lang: 'no', published: null },
                    { path: 'data/links/discover-our-new-ticket-types', name: null, lang: 'fr', published: null },
                    { path: 'data/links/discover-our-new-ticket-types', name: null, lang: 'uk', published: null }
                  ],
                  _stopResolving: true
                },
                title: 'Discover our NEW ticket types!',
                blackList: [],
                component: 'offers',
                description: '',
                backgroundColor: '',
                backgroundImage: {
                  id: 18081448,
                  alt: 'airbaltic offer background',
                  name: '',
                  focus: '',
                  title: 'airbaltic offer background',
                  source: '',
                  filename: 'https://a.storyblok.com/f/260755/1920x320/ab5bc34b6b/offer-bg.jpeg',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {
                    alt: 'airbaltic offer background',
                    title: 'airbaltic offer background',
                    source: '',
                    copyright: ''
                  },
                  is_external_url: false
                },
                _editable:
                  '<!--#storyblok#{"name": "offers", "space": "260755", "uid": "52d53d0e-24a6-40a7-9d41-70486571371c", "id": "553512371"}-->'
              },
              slug: 'discover-our-new-ticket-types',
              full_slug: 'data/offers/discover-our-new-ticket-types',
              sort_by_date: null,
              position: -150,
              tag_list: [],
              is_startpage: false,
              parent_id: 442072860,
              meta_data: null,
              group_id: '8649aebd-a104-4a46-ae0d-97dfe1287b80',
              first_published_at: '2024-09-25T05:27:13.543Z',
              release_id: null,
              lang: 'default',
              path: null,
              alternates: [],
              default_full_slug: 'data/offers/discover-our-new-ticket-types',
              translated_slugs: [
                { path: 'data/offers/discover-our-new-ticket-types', name: null, lang: 'lv', published: null },
                { path: 'data/offers/discover-our-new-ticket-types', name: null, lang: 'lt', published: null },
                { path: 'data/offers/discover-our-new-ticket-types', name: null, lang: 'de', published: null },
                { path: 'data/offers/discover-our-new-ticket-types', name: null, lang: 'et', published: null },
                { path: 'data/offers/discover-our-new-ticket-types', name: null, lang: 'fi', published: null },
                { path: 'data/offers/discover-our-new-ticket-types', name: null, lang: 'ru', published: null },
                { path: 'data/offers/discover-our-new-ticket-types', name: null, lang: 'no', published: null },
                { path: 'data/offers/discover-our-new-ticket-types', name: null, lang: 'fr', published: null },
                { path: 'data/offers/discover-our-new-ticket-types', name: null, lang: 'uk', published: null }
              ],
              _stopResolving: true
            },
            {
              name: 'Mix & match your pre-order meal',
              created_at: '2024-10-29T12:35:21.493Z',
              published_at: '2024-10-29T12:35:32.458Z',
              id: 570808929,
              uuid: '5c3ad996-af56-4be7-81bf-ff6a387f3cf4',
              content: {
                _uid: '10965e2b-7525-4375-8610-28e87148fc3d',
                link: {
                  name: '   \t Mix & match your pre-order meal',
                  created_at: '2024-10-29T12:31:07.998Z',
                  published_at: '2024-10-29T12:31:26.188Z',
                  id: 570803735,
                  uuid: '96408980-f773-42cf-a21a-4c2b4b8faf67',
                  content: {
                    _uid: '53f8a598-0a53-409c-ac9f-24f57257a4c5',
                    href: {
                      id: '',
                      url: ' https://www.airbaltic.com/en/inflight-meals',
                      linktype: 'url',
                      fieldtype: 'multilink',
                      cached_url: ' https://www.airbaltic.com/en/inflight-meals'
                    },
                    icon: '',
                    text: '   \t Mix & match your pre-order meal',
                    image: {
                      id: null,
                      alt: null,
                      name: '',
                      focus: null,
                      title: null,
                      source: null,
                      filename: '',
                      copyright: null,
                      fieldtype: 'asset',
                      meta_data: {}
                    },
                    isCard: false,
                    component: 'link',
                    description: '',
                    whitelistCountries: [],
                    _editable:
                      '<!--#storyblok#{"name": "link", "space": "260755", "uid": "53f8a598-0a53-409c-ac9f-24f57257a4c5", "id": "570803735"}-->'
                  },
                  slug: 'mix-match-your-pre-order-meal',
                  full_slug: 'data/links/offer-links-marketing/mix-match-your-pre-order-meal',
                  sort_by_date: null,
                  position: -90,
                  tag_list: [],
                  is_startpage: false,
                  parent_id: 498876749,
                  meta_data: null,
                  group_id: '38016c57-ac7f-4a0a-be36-b8a8c51ab25e',
                  first_published_at: '2024-10-29T12:31:26.188Z',
                  release_id: null,
                  lang: 'default',
                  path: null,
                  alternates: [],
                  default_full_slug: 'data/links/offer-links-marketing/mix-match-your-pre-order-meal',
                  translated_slugs: [
                    {
                      path: 'data/links/offer-links-marketing/mix-match-your-pre-order-meal',
                      name: null,
                      lang: 'lv',
                      published: null
                    },
                    {
                      path: 'data/links/offer-links-marketing/mix-match-your-pre-order-meal',
                      name: null,
                      lang: 'lt',
                      published: null
                    },
                    {
                      path: 'data/links/offer-links-marketing/mix-match-your-pre-order-meal',
                      name: null,
                      lang: 'de',
                      published: null
                    },
                    {
                      path: 'data/links/offer-links-marketing/mix-match-your-pre-order-meal',
                      name: null,
                      lang: 'et',
                      published: null
                    },
                    {
                      path: 'data/links/offer-links-marketing/mix-match-your-pre-order-meal',
                      name: null,
                      lang: 'fi',
                      published: null
                    },
                    {
                      path: 'data/links/offer-links-marketing/mix-match-your-pre-order-meal',
                      name: null,
                      lang: 'ru',
                      published: null
                    },
                    {
                      path: 'data/links/offer-links-marketing/mix-match-your-pre-order-meal',
                      name: null,
                      lang: 'no',
                      published: null
                    },
                    {
                      path: 'data/links/offer-links-marketing/mix-match-your-pre-order-meal',
                      name: null,
                      lang: 'fr',
                      published: null
                    },
                    {
                      path: 'data/links/offer-links-marketing/mix-match-your-pre-order-meal',
                      name: null,
                      lang: 'uk',
                      published: null
                    }
                  ],
                  _stopResolving: true
                },
                title: 'Mix & match your pre-order meal',
                blackList: [],
                component: 'offers',
                description: '',
                backgroundColor: 'bt-green',
                backgroundImage: {
                  id: null,
                  alt: null,
                  name: '',
                  focus: null,
                  title: null,
                  source: null,
                  filename: '',
                  copyright: null,
                  fieldtype: 'asset',
                  meta_data: {}
                },
                _editable:
                  '<!--#storyblok#{"name": "offers", "space": "260755", "uid": "10965e2b-7525-4375-8610-28e87148fc3d", "id": "570808929"}-->'
              },
              slug: 'mix-match-your-pre-order-meal',
              full_slug: 'data/offers/mix-match-your-pre-order-meal',
              sort_by_date: null,
              position: -170,
              tag_list: [],
              is_startpage: false,
              parent_id: 442072860,
              meta_data: null,
              group_id: '4a094120-62dd-4698-8f5a-b8fc09531174',
              first_published_at: '2024-10-29T12:35:32.458Z',
              release_id: null,
              lang: 'default',
              path: null,
              alternates: [],
              default_full_slug: 'data/offers/mix-match-your-pre-order-meal',
              translated_slugs: [
                { path: 'data/offers/mix-match-your-pre-order-meal', name: null, lang: 'lv', published: null },
                { path: 'data/offers/mix-match-your-pre-order-meal', name: null, lang: 'lt', published: null },
                { path: 'data/offers/mix-match-your-pre-order-meal', name: null, lang: 'de', published: null },
                { path: 'data/offers/mix-match-your-pre-order-meal', name: null, lang: 'et', published: null },
                { path: 'data/offers/mix-match-your-pre-order-meal', name: null, lang: 'fi', published: null },
                { path: 'data/offers/mix-match-your-pre-order-meal', name: null, lang: 'ru', published: null },
                { path: 'data/offers/mix-match-your-pre-order-meal', name: null, lang: 'no', published: null },
                { path: 'data/offers/mix-match-your-pre-order-meal', name: null, lang: 'fr', published: null },
                { path: 'data/offers/mix-match-your-pre-order-meal', name: null, lang: 'uk', published: null }
              ],
              _stopResolving: true
            }
          ],
          component: 'offers-block',
          allOfferLink: { id: '', url: '', linktype: 'story', fieldtype: 'multilink', cached_url: '' },
          _editable:
            '<!--#storyblok#{"name": "offers-block", "space": "260755", "uid": "3ba58b49-7d0c-42f3-bcd7-e54557700f16", "id": "568258268"}-->'
        },
        {
          tag: 'campaignover',
          _uid: '3e269e10-9a51-4bb2-9a5e-c2fdfd51a79f',
          title: 'Subscribe to newsletters',
          component: 'subscribe-blok',
          privacyPolicy:
            "By signing up, you confirm that you have got acquainted with airBaltic's [Privacy Policy](/rules-and-regulations/privacy-policy).",
          subscribeSource: 'campaignover',
          _editable:
            '<!--#storyblok#{"name": "subscribe-blok", "space": "260755", "uid": "3e269e10-9a51-4bb2-9a5e-c2fdfd51a79f", "id": "568258268"}-->'
        }
      ],
      component: 'container-wrapper',
      _editable:
        '<!--#storyblok#{"name": "container-wrapper", "space": "260755", "uid": "6ade1561-3cf8-45bd-b80b-84dcf3a051c4", "id": "568258268"}-->'
    }
  ],
  activeBody: [
    {
      _uid: 'a85b1442-f836-4b40-8bde-2530b91f465f',
      title: 'Cherry sale',
      component: 'clp-banner',
      variation: 'asset_in_counter',
      color_theme: 'purple',
      description:
        "Book flights at incredible prices to hottest destinations – from bustling cities and sun-soaked beaches to cultural hotspots and scenic mountain escapes. It’s your chance to plan fantastic summer trips and unforgettable yearly vacations – don't miss out! ",
      mobile_asset: {
        id: 17787488,
        alt: 'cherry',
        name: '',
        focus: '1295x457:1296x458',
        title: 'cherry',
        source: '',
        filename: 'https://a.storyblok.com/f/260755/2720x916/1a2140da56/tablet_cherry.png',
        copyright: '',
        fieldtype: 'asset',
        meta_data: { alt: 'cherry', title: 'cherry', source: '', copyright: '' },
        content_type: 'png',
        is_external_url: false
      },
      tablet_asset: {
        id: 17787487,
        alt: 'cherry',
        name: '',
        focus: '',
        title: 'cherry',
        source: '',
        filename: 'https://a.storyblok.com/f/260755/1920x1080/a77ae90570/desktop_cherry.png',
        copyright: '',
        fieldtype: 'asset',
        meta_data: { alt: 'cherry', title: 'cherry', source: '', copyright: '' },
        content_type: 'png',
        is_external_url: false
      },
      desktop_asset: {
        id: 17907391,
        alt: 'airbaltic flying is fun',
        name: '',
        focus: '',
        title: 'airbaltic flying is fun',
        source: '',
        filename: 'https://a.storyblok.com/f/260755/x/1b1e7ef16c/airbaltic_flying_is_fun_optimized_no_audio.webm',
        copyright: '',
        fieldtype: 'asset',
        meta_data: { alt: 'airbaltic flying is fun', title: 'airbaltic flying is fun', source: '', copyright: '' },
        is_external_url: false
      },
      _editable:
        '<!--#storyblok#{"name": "clp-banner", "space": "260755", "uid": "a85b1442-f836-4b40-8bde-2530b91f465f", "id": "568258268"}-->'
    }
  ],
  book_date_end: '2024-11-05 23:59',
  book_date_start: '2024-10-20 14:01',
  travel_date_end: '2024-11-21 04:59',
  travel_date_start: '2024-11-21 01:59',
  show_timer: true,
  _editable:
    '<!--#storyblok#{"name": "clp", "space": "260755", "uid": "915f1ba3-8761-46bb-9e73-9c336991c103", "id": "568258268"}-->'
}

export const bigCampaignBlockItemData: {
  [key: string]: BigCampaignBlockItemStoryblok
} = {
  withoutOptionalFields: {
    _uid: 'test1',
    component: 'big-campaign-block-item',
    title: 'Test 1',
    subtext: 'Test 1',
    buttonText: 'Test 1',
    action: {
      id: 'd445f5b2-4366-4c24-aa48-106953031fba',
      url: '/test-accordion-anchor-focus',
      cached_url: '/test-accordion-anchor-focus'
    },
    mobileAsset: {
      id: 1,
      filename: 'test-mobile-asset.jpg',
      name: 'test-mobile-asset',
      alt: 'test-mobile-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    tabletAsset: {
      id: 2,
      filename: 'test-tablet-asset.jpg',
      name: 'test-tablet-asset',
      alt: 'test-tablet-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    smallDesktopAsset: {
      id: 3,
      filename: 'test-small-desktop-asset.jpg',
      name: 'test-small-desktop-asset',
      alt: 'test-small-desktop-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    largeDesktopAsset: {
      id: 4,
      filename: 'test-large-desktop-asset.jpg',
      name: 'test-large-desktop-asset',
      alt: 'test-large-desktop-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    }
  },
  withAllFields: {
    _uid: 'test2',
    component: 'big-campaign-block-item',
    title: 'Test 2',
    subtext: 'Test 2',
    buttonText: 'Test 2',
    bookAFlightTo: '2026-01-02 00:00',
    bookAFlightFrom: '2026-01-02 00:00',
    travelPeriodTo: '2026-01-02 00:00',
    travelPeriodFrom: '2026-01-02 00:00',
    price: '1',
    action: {
      id: 'd445f5b2-4366-4c24-aa48-106953031fba',
      url: '/test-accordion-anchor-focus',
      cached_url: '/test-accordion-anchor-focus'
    },
    mobileAsset: {
      id: 1,
      filename: 'test-mobile-asset.jpg',
      name: 'test-mobile-asset',
      alt: 'test-mobile-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    tabletAsset: {
      id: 2,
      filename: 'test-tablet-asset.jpg',
      name: 'test-tablet-asset',
      alt: 'test-tablet-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    smallDesktopAsset: {
      id: 3,
      filename: 'test-small-desktop-asset.jpg',
      name: 'test-small-desktop-asset',
      alt: 'test-small-desktop-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    largeDesktopAsset: {
      id: 4,
      filename: 'test-large-desktop-asset.jpg',
      name: 'test-large-desktop-asset',
      alt: 'test-large-desktop-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    }
  }
}

export const bigCampaignBlockItemDataWithCountry: {
  [key: string]: BigCampaignBlockItemStoryblok
} = {
  withoutOptionalFields: {
    _uid: 'test1',
    component: 'big-campaign-block-item',
    title: 'Test 1',
    subtext: 'Test 1',
    buttonText: 'Test 1',
    action: {
      id: 'd445f5b2-4366-4c24-aa48-106953031fba',
      url: '/test-accordion-anchor-focus',
      cached_url: '/test-accordion-anchor-focus'
    },
    mobileAsset: {
      id: 1,
      filename: 'test-mobile-asset.jpg',
      name: 'test-mobile-asset',
      alt: 'test-mobile-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    tabletAsset: {
      id: 2,
      filename: 'test-tablet-asset.jpg',
      name: 'test-tablet-asset',
      alt: 'test-tablet-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    smallDesktopAsset: {
      id: 3,
      filename: 'test-small-desktop-asset.jpg',
      name: 'test-small-desktop-asset',
      alt: 'test-small-desktop-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    largeDesktopAsset: {
      id: 4,
      filename: 'test-large-desktop-asset.jpg',
      name: 'test-large-desktop-asset',
      alt: 'test-large-desktop-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    visibleInCountries: ['LV', 'EE']
  },
  withAllFields: {
    _uid: 'test2',
    component: 'big-campaign-block-item',
    title: 'Test 2',
    subtext: 'Test 2',
    buttonText: 'Test 2',
    bookAFlightTo: '2026-01-02 00:00',
    bookAFlightFrom: '2026-01-02 00:00',
    travelPeriodTo: '2026-01-02 00:00',
    travelPeriodFrom: '2026-01-02 00:00',
    price: '1',
    action: {
      id: 'd445f5b2-4366-4c24-aa48-106953031fba',
      url: '/test-accordion-anchor-focus',
      cached_url: '/test-accordion-anchor-focus'
    },
    mobileAsset: {
      id: 1,
      filename: 'test-mobile-asset.jpg',
      name: 'test-mobile-asset',
      alt: 'test-mobile-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    tabletAsset: {
      id: 2,
      filename: 'test-tablet-asset.jpg',
      name: 'test-tablet-asset',
      alt: 'test-tablet-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    smallDesktopAsset: {
      id: 3,
      filename: 'test-small-desktop-asset.jpg',
      name: 'test-small-desktop-asset',
      alt: 'test-small-desktop-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    largeDesktopAsset: {
      id: 4,
      filename: 'test-large-desktop-asset.jpg',
      name: 'test-large-desktop-asset',
      alt: 'test-large-desktop-asset',
      title: '',
      focus: '',
      fieldtype: 'asset'
    },
    visibleInCountries: ['LV', 'EE']
  }
}

export const smallCampaignBlockItemData: SmallCampaignBlockItemStoryblok = {
  _uid: 'test1',
  component: 'small-campaign-block-item',
  title: 'Test 1',
  subtext: 'Test 1',
  buttonText: 'Test 1',
  action: {
    id: 'd445f5b2-4366-4c24-aa48-106953031fba',
    url: '/test-accordion-anchor-focus',
    cached_url: '/test-accordion-anchor-focus'
  },
  mobileAsset: {
    id: 1,
    filename: 'test-mobile-asset.jpg',
    name: 'test-mobile-asset',
    alt: 'test-mobile-asset',
    title: '',
    focus: '',
    fieldtype: 'asset'
  },
  tabletAsset: {
    id: 2,
    filename: 'test-tablet-asset.jpg',
    name: 'test-tablet-asset',
    alt: 'test-tablet-asset',
    title: '',
    focus: '',
    fieldtype: 'asset'
  },
  smallDesktopAsset: {
    id: 3,
    filename: 'test-small-desktop-asset.jpg',
    name: 'test-small-desktop-asset',
    alt: 'test-small-desktop-asset',
    title: '',
    focus: '',
    fieldtype: 'asset'
  },
  largeDesktopAsset: {
    id: 4,
    filename: 'test-large-desktop-asset.jpg',
    name: 'test-large-desktop-asset',
    alt: 'test-large-desktop-asset',
    title: '',
    focus: '',
    fieldtype: 'asset'
  }
}

export const smallCampaignBlockWithImageOnTopItemData: SmallCampaignBlockItemWithImageOnTopStoryblok = {
  _uid: 'test1',
  component: 'small-campaign-block-item-with-image-on-top',
  title: 'Test 1',
  subtext: 'Test 1',
  buttonText: 'Test 1',
  action: {
    id: 'd445f5b2-4366-4c24-aa48-106953031fba',
    url: '/test-accordion-anchor-focus',
    cached_url: '/test-accordion-anchor-focus'
  },
  mobileAsset: {
    id: 1,
    filename: 'test-mobile-asset.jpg',
    name: 'test-mobile-asset',
    alt: 'test-mobile-asset',
    title: '',
    focus: '',
    fieldtype: 'asset'
  },
  tabletAsset: {
    id: 2,
    filename: 'test-tablet-asset.jpg',
    name: 'test-tablet-asset',
    alt: 'test-tablet-asset',
    title: '',
    focus: '',
    fieldtype: 'asset'
  },
  smallDesktopAsset: {
    id: 3,
    filename: 'test-small-desktop-asset.jpg',
    name: 'test-small-desktop-asset',
    alt: 'test-small-desktop-asset',
    title: '',
    focus: '',
    fieldtype: 'asset'
  },
  largeDesktopAsset: {
    id: 4,
    filename: 'test-large-desktop-asset.jpg',
    name: 'test-large-desktop-asset',
    alt: 'test-large-desktop-asset',
    title: '',
    focus: '',
    fieldtype: 'asset'
  }
}

export const anchorSectionTestData: {
  singleSection: AnchorSectionsStoryblok
  multipleSections: AnchorSectionsStoryblok
} = {
  singleSection: {
    component: 'anchor-sections',
    _uid: 'e65f8a4c-e764-4150-824c-3e86cb37f5d1',
    sections: [
      {
        name: 'test-section-1',
        uuid: 'uuid-1',
        id: 1,
        slug: 'test-section-1',
        full_slug: 'test/section-1',
        content: {
          _uid: 'test-anchor-section-1',
          component: 'anchor-section',
          title: 'Test Section 1',
          anchor: 'test-section-1',
          content: [
            {
              _uid: 'test-anchor-section-wysiwyg-1',
              component: 'wysiwyg',
              content: 'test wysiwyg content'
            },
            {
              _uid: 'test-anchor-section-info-block-cta-1',
              component: 'info-block-cta',
              text: [],
              cta: 'test-cta'
            }
          ]
        },
        alternates: [],
        created_at: '',
        published_at: '',
        first_published_at: '',
        group_id: '',
        lang: 'default',
        meta_data: null,
        parent_id: 0,
        path: '',
        position: 0,
        tag_list: [],
        translated_slugs: [],
        sort_by_date: null
      }
    ]
  },
  multipleSections: {
    component: 'anchor-sections',
    _uid: 'e65f8a4c-e764-4150-824c-3e86cb37f5d1',
    sections: [
      {
        name: 'test-section-1',
        uuid: 'uuid-1',
        id: 1,
        slug: 'test-section-1',
        full_slug: 'test/section-1',
        content: {
          _uid: 'test-anchor-section-1',
          component: 'anchor-section',
          title: 'Test Section 1',
          anchor: 'test-section-1',
          content: [
            {
              _uid: 'test-anchor-section-wysiwyg-1',
              component: 'wysiwyg',
              content: 'test wysiwyg content'
            },
            {
              _uid: 'test-anchor-section-info-block-cta-1',
              component: 'info-block-cta',
              text: [],
              cta: 'test-cta'
            }
          ]
        },
        alternates: [],
        created_at: '',
        published_at: '',
        first_published_at: '',
        group_id: '',
        lang: 'default',
        meta_data: null,
        parent_id: 0,
        path: '',
        position: 0,
        tag_list: [],
        translated_slugs: [],
        sort_by_date: null
      },
      {
        name: 'test-section-2',
        uuid: 'uuid-2',
        id: 2,
        slug: 'test-section-2',
        full_slug: 'test/section-2',
        content: {
          _uid: 'test-anchor-section-2',
          component: 'anchor-section',
          title: 'Test Anchor 2',
          anchor: 'test-anchor-2',
          content: [
            {
              _uid: 'test-anchor-section-wysiwyg-1',
              component: 'wysiwyg',
              content: 'test wysiwyg content'
            },
            {
              _uid: 'test-anchor-section-info-block-cta-1',
              component: 'info-block-cta',
              text: [],
              cta: 'test-cta'
            }
          ]
        },
        alternates: [],
        created_at: '',
        published_at: '',
        first_published_at: '',
        group_id: '',
        lang: 'default',
        meta_data: null,
        parent_id: 0,
        path: '',
        position: 0,
        tag_list: [],
        translated_slugs: [],
        sort_by_date: null
      },
      {
        name: 'test-section-3',
        uuid: 'uuid-3',
        id: 3,
        slug: 'test-section-3',
        full_slug: 'test/section-3',
        content: {
          _uid: 'test-anchor-section-3',
          component: 'anchor-section',
          title: 'Test Section 3',
          anchor: 'test-section-3',
          content: [
            {
              _uid: 'test-anchor-section-wysiwyg-1',
              component: 'wysiwyg',
              content: 'test wysiwyg content'
            },
            {
              _uid: 'test-anchor-section-info-block-cta-1',
              component: 'info-block-cta',
              text: [],
              cta: 'test-cta'
            }
          ]
        },
        alternates: [],
        created_at: '',
        published_at: '',
        first_published_at: '',
        group_id: '',
        lang: 'default',
        meta_data: null,
        parent_id: 0,
        path: '',
        position: 0,
        tag_list: [],
        translated_slugs: [],
        sort_by_date: null
      },
      {
        name: 'test-section-4',
        uuid: 'uuid-4',
        id: 4,
        slug: 'test-section-4',
        full_slug: 'test/section-4',
        content: {
          _uid: 'test-anchor-section-4',
          component: 'anchor-section',
          title: 'Test Section 4',
          anchor: 'test-section-4',
          content: [
            {
              _uid: 'test-anchor-section-wysiwyg-1',
              component: 'wysiwyg',
              content: 'test wysiwyg content'
            },
            {
              _uid: 'test-anchor-section-info-block-cta-1',
              component: 'info-block-cta',
              text: [],
              cta: 'test-cta'
            }
          ]
        },
        alternates: [],
        created_at: '',
        published_at: '',
        first_published_at: '',
        group_id: '',
        lang: 'default',
        meta_data: null,
        parent_id: 0,
        path: '',
        position: 0,
        tag_list: [],
        translated_slugs: [],
        sort_by_date: null
      },
      {
        name: 'test-section-5',
        uuid: 'uuid-5',
        id: 5,
        slug: 'test-section-5',
        full_slug: 'test/section-5',
        content: {
          _uid: 'test-anchor-section-5',
          component: 'anchor-section',
          title: 'Test Section 5',
          anchor: 'test-section-5',
          content: [
            {
              _uid: 'test-anchor-section-wysiwyg-1',
              component: 'wysiwyg',
              content: 'test wysiwyg content'
            },
            {
              _uid: 'test-anchor-section-info-block-cta-1',
              component: 'info-block-cta',
              text: [],
              cta: 'test-cta'
            }
          ]
        },
        alternates: [],
        created_at: '',
        published_at: '',
        first_published_at: '',
        group_id: '',
        lang: 'default',
        meta_data: null,
        parent_id: 0,
        path: '',
        position: 0,
        tag_list: [],
        translated_slugs: [],
        sort_by_date: null
      }
    ]
  }
}

function fareStoryForFareTypesTest(uid: string, title: string) {
  const fare: FareStoryblok = {
    _uid: uid,
    component: 'fare',
    title,
    subtext: `${title} subtext`,
    recommended: false,
    items: []
  }

  return fakeISbStoryData(fare)
}

export const fareTypesTestData: FareTypesStoryblok = {
  _uid: 'fare-types-1',
  component: 'fare-types',
  economy: [
    fareStoryForFareTypesTest('economy-1', 'Economy Basic'),
    'remove-me',
    fareStoryForFareTypesTest('economy-2', 'Economy Flex')
  ],
  business: [fareStoryForFareTypesTest('business-1', 'Business Experience')]
}
